import TooltipButton, { TooltipTarget } from "./TooltipButton";

export { TooltipTarget };
export default TooltipButton;
